/* eslint-disable no-console */
import React from 'react';
import { Popover, Stack } from '@mui/material';
import { reactions } from '..';

const commonStyles = {
	height : 'var(--pixel24)',
	width  : 'var(--pixel24)',
	sx     : {
		'&:hover img' : {
			transform  : 'scale(1.5)',
			transition : 'transform 0.3s ease-in-out'
		}
	}
};

const ReactionPopover = (props:any) =>
{
	const { open, eventState, onReactionClick, setEventState } = props;
	const { anchorEl } = eventState;

	// Handle popup close
	const handleClose = () =>
	{
		setEventState((prev: any) => ({ ...prev, anchorEl: null }));
	};

	if (!reactions || reactions?.length === 0) return null;

	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			onClose={handleClose}
			anchorOrigin={{
				vertical   : 'bottom',
				horizontal : 'left'
			}}
		>
			<Stack direction='row' alignItems='center' spacing={1} p='var(--pixel8)' sx={{ cursor: 'pointer' }}>
				{reactions?.map((reaction) => (
					<button
						key={reaction?.key}
						onClick={() => onReactionClick(reaction?.key)}
						aria-label={`React with ${reaction?.alt}`}
						className='reaction-button'
						// {...commonStyles}
						style={{
							height : reaction?.key === 'r3' ? '22px' : 'var(--pixel24)',
							width  : reaction?.key === 'r3' ? '22px' : 'var(--pixel24)'
						}}
					>
						<img src={reaction?.imgSrc} alt={reaction?.alt}/>
					</button>
				))}
			</Stack>
		</Popover>
	);
};

export default ReactionPopover;
